module.exports = __webpack_public_path__ + "static/media/1POLICY36.dca68ec2.jpg";